<template>
    <el-dialog class="editor-dialog" :title="'HTC'+ String(model.seq).padStart(5, '0')+'合同详情'" append-to-body :visible.sync="visible" :show-close="false" width="85%" top="2vh">
      <el-tabs type="card" v-model="activeTabName">
        <el-tab-pane label="基本信息" name="1">
          <el-descriptions direction="vertical" :column="1" border>  
            <el-descriptions-item label="关联采购单">{{'PC'+ String(model.matchedPurchase.seq).padStart(5, '0')}}</el-descriptions-item>   
            <el-descriptions-item label="合同描述">{{model.description}}</el-descriptions-item>
            <el-descriptions-item label="合同金额"><el-tag size="small">{{model.currency=='CNY'?model.contractAmount.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' }):model.contractAmount.toLocaleString('en-US', { style: 'currency', currency:'USD' })}}</el-tag></el-descriptions-item>
            <el-descriptions-item label="销售方">
              <el-tag size="small">{{calcSupplier(model.party)}}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="签署日期">
              <el-tag size="small">{{calcDate(model.signedDate)}}</el-tag>        
            </el-descriptions-item>
            <!-- <el-descriptions-item label="合同货期(天)">
              <div style="min-height:20px">
                <el-tag size="small" v-if="model.deliveryTime">{{model.deliveryTime}}</el-tag>                  
              </div>
            </el-descriptions-item> -->
            <el-descriptions-item label="最晚交货日">
              <div style="min-height:20px">
                <el-tag v-if="model.signedDate&&model.deliveryTime" size="small">{{calcLatestDeliveryTime(model)}}</el-tag>                 
              </div>   
            </el-descriptions-item>
            <el-descriptions-item label="附件">
              <div style="display:flex;flex-flow:row wrap;justify-content:start;">
                <div v-for="(file,index) in model.attachments" :key="index" style="position: relative;margin:0 3px">
                  <el-tooltip class="item" effect="dark" :content="file.filename" placement="top">
                    <el-image class="image" v-if="['.pdf','.PDF'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pdf.png')" fit="cover" @click="previewAttachment(file.path,file.filename,'pdf')"></el-image>
                    <el-image class="image" v-if="['.xls','.xlsx','.XLS','.XLSX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/xlsx.png')" fit="cover" @click="previewAttachment(file.path,file.filename,'excel')"></el-image>
                    <el-image class="image" v-if="['.doc','.docx','.DOC','.DOCX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/docx.png')" fit="cover" @click="previewAttachment(file.path,file.filename,'word')"></el-image>
                    <el-image class="image" v-if="['.ppt','.pptx','.PPT','.PPTX'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/pptx.png')" fit="cover" @click="previewAttachment(file.path,file.filename,'ppt')"></el-image>
                    <el-image class="image" v-if="['.avi','.mpg','.mpeg','.wmv','.mpeg-4','.rmvb','.mkv','.flv','.mov','.mp4','.3gp'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/video.png')" fit="cover" @click="previewAttachment(file.path,file.filename,'video')"></el-image>
                    <el-image class="image" v-if="['.jpg','.jpeg','.png','.bmp','.gif','.tiff','.JPG','.JPEG','.PNG','.BMP','.GIF'].includes(file.filename.substring(file.filename.lastIndexOf('.')))" :src="require('@/assets/images/format/jpeg.png')" fit="cover" @click="previewAttachment(file.path,file.filename,'image')"></el-image>
                    <el-image class="image" v-else :src="require('@/assets/images/format/other.png')" fit="cover" @click="previewAttachment(file.path,file.filename,'other')"></el-image>
                  </el-tooltip>
                </div>
              </div>    
            </el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="合同明细" name="2">
          <el-table :data="items" header-align="center" size="small" highlight-current-row :cell-style="{padding:'5px',fontSize:'13px',borderColor:'#ddd'}" ref="multipleTable" height='500' :row-style="{height:'45px'}" border stripe :header-cell-style="headerStyle">
              <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
              <el-table-column prop="matchedOrderProduct.list.name" label="产品名称" align="center" min-width="100"></el-table-column>
              <el-table-column prop="matchedOrderProduct.list.description" label="规格描述" align="left" min-width="200"></el-table-column>
              <el-table-column prop="matchedOrderProduct.list.brand" label="品牌" align="center" min-width="100"></el-table-column>
               <el-table-column prop="matchedOrderProduct.list.unit" label="单位" align="center" width="70"></el-table-column>
              <el-table-column prop="list.quantity" label="数量" align="center" min-width="80"></el-table-column>
              <el-table-column label="采购单价" align="center" min-width="100" :formatter="calcUnitPrice"></el-table-column>
              <el-table-column label="采购合价" align="center" min-width="100" :formatter="calcSubtotalPrice"></el-table-column>
              <el-table-column label="入库比例" align="center" width="90">
                <template slot-scope="scope">
                  <el-tag type="primary" effect="plain" size="mini">{{ calcCheckinRate(scope.row) }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="出库比例" align="center" width="90">
                <template slot-scope="scope">
                  <el-tag type="success" effect="plain" size="mini">{{ calcCheckoutRate(scope.row) }}</el-tag>
                </template>
              </el-table-column>
            </el-table>  
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </template>
  <script>
  import http from '@/http'
  import dateformat from 'dateformat'
  export default {
  data() {
    return {
      visible: false,
      supplierList:[],
      model:{contractAmount:0,matchedPurchase:{}},
      contractId:'',
      items:[],
      activeTabName:'1'
    };
  },
  methods:{
    async previewAttachment(path,filename,type){
      const res= await http.get('/oss/signatureUrl',{params:{url:path}})  
      this.attachmentViewer(res.data,filename,type,()=>{})  
    }, 
    calcDate(date){
      return dateformat(date, 'yyyy-mm-dd')
    },
    calcSupplier(supplier){
      const s=this.supplierList.find(item=>item._id==supplier)
      if(s){
        return s.name        
      }
    }, 
    async fetchSupplier(){
      const res=await http.get('/purchase/supplier');
      this.supplierList=res.data
    },
    calcLatestDeliveryTime(row){
      const a=new Date(row.signedDate).getTime()+row.deliveryTime*24*3600*1000
      return dateformat(new Date(a), "yyyy-mm-dd")
    },
    async fetchContract() {
      const res = await http.get(`contract/id/${this.contractId}`);
      this.model = res.data[0]
      this.items=res.data
    },
    calcUnitPrice(row){
      if(row.list){
        if(row.list.purchaseCurrency=='CNY'){
          return row.list.purchaseUnitPrice.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })
        }else{
          return row.list.purchaseUnitPrice.toLocaleString('en-US', { style: 'currency', currency:'USD' })
        }        
      }
    },
    calcSubtotalPrice(row, column, cellValue, index){
      if(row.list){
        if(row.list.purchaseCurrency=='CNY'){
          return (row.list.purchaseUnitPrice*row.list.quantity).toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })
        }else{
          return (row.list.purchaseUnitPrice*row.list.quantity).toLocaleString('en-US', { style: 'currency', currency:'USD' })
        }        
      }
    },
    calcCheckinRate(row, column, cellValue, index){
      if(row.list&&row.matchedCheckinProduct){
        const n=row.matchedCheckinProduct.reduce((pre,cur)=>{
          return pre+cur.product.quantity_in
        },0)
        return (100*n/row.list.quantity).toFixed(1)+'%'        
      }else{
        return (0).toFixed(1)+'%'
      }
    },
    calcCheckoutRate(row, column, cellValue, index){
      if(row.list&&row.matchedCheckoutProduct){
        const n=row.matchedCheckoutProduct.reduce((pre,cur)=>{
          return pre+cur.product.quantity_out
        },0)
        return (100*n/row.list.quantity).toFixed(1)+'%'        
      }else{
        return (0).toFixed(1)+'%'
      }
    },
  },
  created(){
    this.fetchContract()
    this.fetchSupplier()
  }
  };
  </script>
  <style scoped>
  .editor-dialog>>>.el-dialog__header {
    text-align: center !important;
    padding:5px;
  }
  .editor-dialog>>>.el-dialog__body {
    padding:5px;
  }
  .editor-dialog>>>.el-dialog__title {
    font-weight: 700 !important;
  }
  .editor-dialog>>>.el-textarea__inner{
    font-family: Arial, Helvetica, sans-serif;
  }
  .editor-dialog>>>.el-descriptions__header{
    display: none;
  }
  .editor-dialog>>>.el-tabs__header{
    margin:3px;
  }
  .image{
    height: 40px;
    width: 40px;
    margin: auto;
    cursor: pointer;
  }
  </style>
  